import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ScheduleIcon from "@mui/icons-material/Schedule";

import { useWidget } from "/imports/state/WidgetContext";
import { checkInOpensLabel } from "/imports/hooks/useCheckInOpen";

/**
 * "Check-in opens 09:45" on a row whose window hasn't arrived yet, so a client
 * looking for the button before it exists is told when to come back.
 *
 * Nothing renders when there is no window, which is also how a club with
 * check-in switched off stays silent: the server sends no window at all, so
 * neither this nor the button has anything to draw.
 */
function CheckInHint({ phase, opensAt }) {
  const { saas } = useWidget();

  if (phase !== "before") return null;

  const label = checkInOpensLabel(opensAt, saas?.timeZone);
  if (!label) return null;

  return (
    <Box display="flex" alignItems="center" gap={0.5} sx={{ color: "text.secondary", flexShrink: 0 }}>
      <ScheduleIcon sx={{ fontSize: "1rem" }} />
      <Typography variant="caption" fontWeight={500}>
        Check-in opens {label}
      </Typography>
    </Box>
  );
}

export default CheckInHint;
